import PhoneFilterInput from './PhoneFilterInput'
import NumberFilterInput from './NumberFilterInput'
import TextFilterInput from './TextFilterInput'
import MultiSelectFilterInput from './MultiSelectFilterInput'
import PriceFilterInput from './PriceFilterInput'
import ImageFilterInput from './ImageFilterInput'
import SwitchFilterInput from './SwitchFilterInput'
import JalaliDateFilterInput from './JalaliDateFilterInput'
// import MapFilterInput from './MapFilterInput'
// import MapFilterInputLeaflet from './MapFilterInputLeaflet'

import DateFilterInput from './DateFilterInput'
import FromToInput from './FromToInput'
import SelectListInput from './SelectListInput'


const inputComponents = {
    PhoneInput: PhoneFilterInput,
    NumberInput: NumberFilterInput,
    TextInput: TextFilterInput,
    JalaliDateInput: JalaliDateFilterInput,
    SelectInput: MultiSelectFilterInput,
    TextAreaInput: TextFilterInput,
    PriceInput: PriceFilterInput,
    AdvancedSelectInput: MultiSelectFilterInput,
    MultiSelectInput: MultiSelectFilterInput,
    // ImageInput:ImageFilterInput,
    SwitchInput: SwitchFilterInput,
    // MapFilterInput: MapFilterInputLeaflet,
    FromToInput: FromToInput,
    // DateInput: DateFilterInput,
    SelectListInput: SelectListInput,
    MultiLevelInput:MultiSelectFilterInput
}

export default (inputComponents);